import { useAtomValue, useSetAtom } from 'jotai';

import {
  currentTraderAccountAtom,
  fetchCurrentTraderAccountAtom,
} from 'data/traders/account/atoms/currentTraderAccountAtom';
import { getOptional, map } from 'utils/remote';

export function useCurrentTraderAccount() {
  return useAtomValue(currentTraderAccountAtom);
}

export function useFetchTraderAccount() {
  return useSetAtom(fetchCurrentTraderAccountAtom);
}

export function useCurrentTraderRole() {
  const remote = useCurrentTraderAccount();

  return map(remote, ({ role }) => role);
}

export function useCurrentTraderPriority() {
  const remote = useCurrentTraderAccount();

  return map(remote, ({ credentialsPriority }) => credentialsPriority);
}

export function useIsAdmin() {
  const role = useCurrentTraderRole();

  return ['ADMIN', 'OWNER'].includes(getOptional(role) ?? 'TRADER');
}
